import { History } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import UsageLogItem from './UsageLogItem';
import { ICON_SIZE } from '../design-system';

const UsageHistoryTab = ({ historyLoading, logs, hasMore, loadMore }) => {
  const { t } = useTranslation('modals');

  return (
    <div className="usage-history-section">
      <div className="usage-history-header">
        <History size={ICON_SIZE.lg} />
        <span>{t('usage.recentUsage')}</span>
      </div>

      {historyLoading ? (
        <div className="usage-loading">{t('common.loading', { defaultValue: 'Loading...' })}</div>
      ) : logs.length === 0 ? (
        <div className="usage-empty">
          <p>{t('usage.noHistory')}</p>
          <p className="usage-empty-hint">{t('usage.noHistoryHint')}</p>
        </div>
      ) : (
        <>
          <div className="usage-history-list">
            {logs.map(log => (
              <UsageLogItem key={log.id} log={log} />
            ))}
          </div>
          {hasMore && (
            <button className="usage-load-more" onClick={loadMore}>
              {t('common.loadMore', { defaultValue: 'Load More' })}
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default UsageHistoryTab;
